<template>
  <div class="px-2 text-gray pb-4">
    <div class="pb-4 text-xs text-black">Formulas</div>
    <div v-for="(f, i) in formulas" class="py-4 pl-4 border-l-4 border-b border-gray-lighter">
      <div class="font-normal tracking-wide">
        <div class="font-bold leading-normal text-sm pb-1">
          {{i + 1}}. $$ {{f.name || '()'}}</a>
        </div>
        <div class="text-sm leading-normal pb-2">
          <p class="code">{{f.text}}</p>
        </div>

        <div class="text-normal font-bold leading-normal">
          <p v-if="f.result.error" class="text-red-dark">ERROR: {{f.result.error.message}}</p>
          <p v-else>> {{f.result}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 export default {
   props: {
     formulas: {
       type: Array,
       required: true
     }
   }
 }
</script>
